














































































































/* General */
import Vue from 'vue'
import MailboxSettingsLayout from '@/layouts/mailbox-settings-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'
import WorkflowAPI from '@/api/modules/workflows.api'
import {
  IChecklistTemplate,
  IItemForSelection,
} from '@/api/types/response.types'

export default Vue.extend({
  name: 'MailboxSettingsChecklistTemplates',

  metaInfo(): any {
    return {
      title: `Checklist Templates - ${this.name}`,
    }
  },

  components: {
    MailboxSettingsLayout,
    EntitySettingsLoading,
  },

  data() {
    return {
      ColorAssistant,
      isLoading: true,
      isSubmitting: false,
      editingID: null as number,
      name: '',
      checklistTemplates: [] as IChecklistTemplate[],
      editingTemplate: {} as IChecklistTemplate,
      listStatuses: [] as IItemForSelection[],
      modalOpened: false,
      rules: {
        title: [
          {
            required: true,
            trigger: 'submit',
            message: 'Title is required',
          },
        ],
        template: [
          {
            required: true,
            trigger: 'submit',
            message: 'Template is required',
          },
        ],
      },
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
    isEditing(): boolean {
      return this.editingID != null
    },
    hasDescTemplates(): boolean {
      return this.checklistTemplates.length > 0
    },
  },

  watch: {
    modalOpened(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          // @ts-ignore
          this.$refs.savedTemplateForm_Title.focus()
        })
      }
    },
  },

  async created() {
    this.isLoading = true
    await this.getTemplates()
    this.isLoading = false
  },

  methods: {
    async getTemplates() {
      try {
        const projectInfoResponse = await MailboxesAPI.get_WithWorkflow(this.id)
        this.name = projectInfoResponse.title
        this.checklistTemplates = await MailboxesAPI.get_ChecklistTemplates(
          this.id,
        )
        const workflowStatusList = await WorkflowAPI.get_Statuses(
          projectInfoResponse.workflowID,
        )
        this.listStatuses = [{ id: null, name: '-- DO NOT ADD --' }].concat(
          workflowStatusList,
        )
      } catch (error) {
        this.$error.emit(error as any)
      }
    },
    async saveTemplate() {
      // @ts-ignore
      this.$refs.editTemplateForm.validate((valid: boolean) => {
        if (valid) {
          this.isSubmitting = true
          try {
            if (this.isEditing) {
              const respone = MailboxesAPI.put_ChecklistTemplateUpdate(
                this.id,
                this.editingID,
                { checklistTemplate: this.editingTemplate },
              )
            } else {
              const respone = MailboxesAPI.post_ChecklistTemplateCreate(
                this.id,
                { checklistTemplate: this.editingTemplate },
              )
            }
          } catch (error) {
            this.$error.emit(error as any, true)
          } finally {
            this.isSubmitting = false
          }
          this.closeModal()
        }
      })
    },

    beginEditTemplate(id: number): void {
      this.editingTemplate = this.checklistTemplates.find(dt => dt.id === id)
      this.modalOpened = true
      this.editingID = id
    },

    beginCreateTemplate(): void {
      this.editingTemplate = {
        checklistTemplateItems: [],
      } as IChecklistTemplate
      this.modalOpened = true
      this.editingID = null
    },

    async removeTemplate(id: number) {
      await this.$confirm(
        `Are you sure you want to delete this template?<br />
         This cannot be undone.`,
        {
          dangerouslyUseHTMLString: true,
          center: true,
          confirmButtonText: 'Yes, Delete',
          confirmButtonClass: 'el-button--strawberry',
          cancelButtonText: 'Cancel',
          cancelButtonClass: 'el-button--text',
          type: 'warning',
          title: `Delete Checklist Template`,
        },
      )
      await this.deleteChecklistTemplate(id)
    },

    closeModal(): void {
      this.getTemplates()
      this.modalOpened = false
      // @ts-ignore
      this.$refs.editTemplateForm.clearValidate()
    },

    async deleteChecklistTemplate(id: number) {
      try {
        this.isSubmitting = true
        const response = await MailboxesAPI.delete_ChecklistTemplateDelete(
          this.id,
          id,
        )
        this.$messaging.showSuccess(response.message)
      } catch (error) {
        this.$error.emit(error as any, true)
      } finally {
        await this.getTemplates()
        this.isSubmitting = false
      }
    },

    statusLabel(statusID: number | null): string {
      if (statusID == null) {
        return ''
      }

      return (
        '(' +
        this.listStatuses.find(status => status.id === statusID).name +
        ')'
      )
    },
  },
})
